export default {
  namespaced: true,
  state: {
    objects: [],
    object: null,
    meta: {},
    objectsList: [],
    activeObjectsList: [],
  },
  actions: {

    GetObjectsList({ commit, rootGetters }, payload) {
      commit('setField', { name: 'objects', value: [] });
      return rootGetters.axl.post('objects/api/objects/list', payload)
        .then((response) => {
          commit('setField', { name: 'objects', value: response.data.objects });
        });
    },


    GetObject({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'object', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('objects/api/objects/view', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'object', value: response.data.object });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },

    /** Получение объектов */
    GetObjects({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'objectsList', value: null });
      commit('setField', { name: 'objects', value: null });
      commit('setField', { name: 'activeObjectsList', value: null });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('objects/api/objects/list', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'objects', value: response.data.objects });
              commit('setField', { name: 'objectsList', value: response.data.objects });
              commit('setField', { name: 'activeObjectsList', value: response.data.objects.filter(item => item.status === 'approved') });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },


    ClearObject({ commit }) {
      commit('setField', { name: 'object', value: null });
    },
    ClearObjects({ commit }) {
      commit('setField', { name: 'objects', value: [] });
    },

    InitialStore({ commit }) {
      commit('setField', { name: 'objects', value: [] });
      commit('setField', { name: 'object', value: null });
      commit('setField', { name: 'meta', value: {} });
      commit('setField', { name: 'objectsList', value: [] });
      commit('setField', { name: 'activeObjectsList', value: [] });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
    setObjects(state, objects) {
      objects.forEach(item => state.objects.push(item));
    },
  },
};
